module.exports = {
  'peacock-blue': '#006491',
  'dark-blue': '#005781',
  'light-navy': '#143b62',
  'half-lipstick': '#f499a9',
  'lipstick': '#e11d38',
  'dark-red': '#9d2235',
  'rouge': '#a71e22',
  'white': '#ffffff',
  'white-two': '#f6f5f5',
  'black': '#000000',
  'grey-brown': '#555555',
  'medium-grey': '#767676',
  'light-grey': '#a6a6a6',
  'faint-grey': '#DDDDDD'
}



// WEBPACK FOOTER //
// ./src/vars/colors.js